export default "__VITE_ASSET__DY7RqU2y__"